import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";

interface SelectionStartStatusOption {
  text: string
  value: number
};

const selectionStartDropdownOptions: SelectionStartStatusOption[] = [
  { text: RESX.DateTime.YDay, value: 1 },
  { text: RESX.DateTime.YMonth, value: 31 },
  { text: RESX.DateTime.XMonths.replace("{0}", "6"), value: 182 },
  { text: RESX.DateTime.YYear, value: 365 },
  { text: RESX.DateTime.XYears.replace("{0}", "2"), value: 730 },
  { text: RESX.DateTime.XYears.replace("{0}", "3"), value: 1095 },
  { text: RESX.DateTime.XYears.replace("{0}", "4"), value: 1460 },
  { text: RESX.DateTime.XYears.replace("{0}", "5"), value: 1825 }
];

export const getSelectionStartDropdownLabel = (value: number): string => {
  const option = selectionStartDropdownOptions.find(o => o.value === value);
  return option ? option.text : "";
}

const SelectionStartDropdown = (props: DropdownWithoutOptionsProps<number, number>) => {
  const selectedOption = selectionStartDropdownOptions.find(o => o.value === props.value);

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={selectionStartDropdownOptions}
    getLabel={(t) => t.text}
    getValue={(t) => t.value}
    value={selectedOption}
    onChange={v => { props.onChange(v.value); }}
    config={{
      isSearchable: false,
      ...props.config
    }}
  />;
};

export default SelectionStartDropdown;